const { CarouselElement } = window.BAO.Carousel
const { setInitialised, useDots } = window.BAO.Carousel.plugins

class ImageSwiper extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide', 'thumbnail']
  }

  setupListeners () {
    super.setupListeners()

    this.onLayoutUpdate = this.onLayoutUpdate.bind(this)

    if (this.externalEls?.grid) {
      this.listeners.add(
        this.externalEls.grid.element,
        'click',
        this.onLayoutUpdate,
      )
    }
    if (this.externalEls?.list) {
      this.listeners.add(
        this.externalEls.list.element,
        'click',
        this.onLayoutUpdate,
      )
    }
  }

  onLayoutUpdate () {
    // doesn't seem to be any event emitters on the product grid layout switches
    setTimeout(() => {
      this.carousel.update()
    }, 16)
  }

  get options () {
    return {
      slides: {
        perView: 1,
        spacing: 0,
      },
    }
  }

  get plugins () {
    return [setInitialised(), useDots(this.els.thumbnail.elements)]
  }
}

const viewportWidth =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth

if (!customElements.get('image-swiper') && viewportWidth <= 768) {
  customElements.define('image-swiper', ImageSwiper)
} else if (viewportWidth > 768) {
  document.querySelectorAll('[data-image-swiper-el]').forEach(slider => {
    slider.classList.remove('keen-slider')
    slider.classList.remove('keen-slider__slide')
  })
}
